var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6162_21350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0601 8.565L12.0301 4.3275C11.7751 3.9675 11.3626 3.75 10.9201 3.75C9.80256 3.75 9.15756 5.01 9.80256 5.9175L12.0001 9L9.80256 12.0825C9.15006 12.99 9.80256 14.25 10.9201 14.25C11.3626 14.25 11.7826 14.0325 12.0376 13.6725L15.0676 9.435C15.2476 9.1725 15.2476 8.8275 15.0601 8.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81006 8.565L6.78756 4.3275C6.52506 3.9675 6.11256 3.75 5.67006 3.75C4.55256 3.75 3.90006 5.01 4.55256 5.9175L6.75006 9L4.55256 12.0825C3.90006 12.99 4.55256 14.25 5.67006 14.25C6.11256 14.25 6.53256 14.0325 6.78756 13.6725L9.81756 9.435C9.99756 9.1725 9.99756 8.8275 9.81006 8.565Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6162_21350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.ae6fd352ab08b09751e205794385528d.svg";
export { ForwardRef as ReactComponent };